import { PositiveColors, Shadows } from '@picsart/design-system/foundation/colors';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';

type StyleProps = {
  gradient?: string;
};

const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: (props: StyleProps) =>
      `linear-gradient(to top, #FFF 20%, rgba(0,0,0,0) 20%), ${
        props?.gradient || 'linear-gradient(93deg, #E1CFFF 0%, #FFDCFF 99.13%)'
      }`,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: [Spacings.s32, Spacings.s16],
    gap: Spacings.s32,
  },
  wheel: {
    width: 242,
    height: 186,
    background: PositiveColors.base.default,
    borderRadius: CornerRadius.r12,
    padding: Spacings.s4,
    boxShadow: Shadows.tint2,
    '@media screen and (max-width: 767px)': {
      width: '100%',
      height: '100%',
      maxWidth: 312,
    },
  },
  description: {
    fontWeight: FontWeights.medium,
  },
  header: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: Spacings.s16,
    // [mediaQuery(767)]: {
    '@media screen and (max-width: 767px)': {
      width: '100%',
    },
  },
  // Skeleton
  wrapperSkeleton: {
    extend: 'wrapper',
    width: '100%',
    height: 348,
  },
});

export default useStyles;
